export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const ENDPOINTS = {
  JOBS: 'jobs/v1/job-posts',
  APPLICATION: 'jobs/v1/applications'
};
